<template>
  <div class="meta-row">
    <button
      v-if="(!isActiveSoloCarta || isAdmin) && getCartProductQty(menuGroup)"
      type="button"
      class="order-button remove-product"
      @click="removeOneFromCart(menuGroup)"
    >
      <font-awesome-icon
        icon="minus-square"
        :style="{ color: '#ea2222', fontSize: 20 }"
      />
    </button>

    <button
      v-if="(!isActiveSoloCarta || isAdmin) && !isOnlyMenu"
      type="button"
      class="order-button add-product"
      @click="openGroupProductDialog()"
    >
      <font-awesome-icon
        icon="plus-square"
        :style="{ color: '#11bd11', fontSize: 20 }"
      />
    </button>

    <span v-if="getCartProductQty(menuGroup)" class="cart-quantity"
      >{{ getCartProductQty(menuGroup) }}x</span
    >
    <div class="product-price" :style="{ color: listItemPriceColorTheme }">
      {{ formatPrice(menuGroup.price) }}
    </div>
    <GroupProductDialog
      :menuGroup="menuGroup"
      :drinks="drinks"
      :dessert="dessert"
      :starters="starters"
      :maincourse="maincourse"
      :isAdmin="isAdmin"
      ref="groupProductDialog"
    >
    </GroupProductDialog>
    <email-modal ref="emailModalRef"></email-modal>
    <QrValidationModal
      :check-q-r="checkQR"
      @closeQrValidationModal="closeQrValidationModal"
      :isAdmin="isAdmin"
    ></QrValidationModal>
  </div>
</template>

<script>
import GroupProductDialog from "@/components/public/products/SelectItems/GroupProductDialog";
import QrValidationModal from "@/components/public/modals/QrValidationModal";
import EmailModal from "@/components/public/modals/EmailModal.vue";
const NO_QR = "NO QR";

export default {
  name: "add-to-cart-group-product",
  props: {
    menuGroup: Object,
    drinks: Array,
    dessert: Array,
    starters: Array,
    maincourse: Array,
    isAdmin: Boolean
  },
  components: {
    GroupProductDialog,
    EmailModal,
    QrValidationModal
  },
  data() {
    return {
      size: "base",
      checkQR: false,
      groupProductDialog: false
    };
  },
  computed: {
    tableQR() {
      return !this.isAdmin
        ? this.$store.state.tableQR
        : this.$store.state.adminTableQR;
    },
    getEmail() {
      return this.$store.getters.getEmail(this.isAdmin);
    }
  },
  methods: {
    openGroupProductDialog() {
      if (!this.getEmail) {
        this.$refs.emailModalRef.open();
        return;
      }
      //this.groupProductDialog = true;
      this.$refs.groupProductDialog.open();
    },
    getCartProductQty(product) {
      const { cart, admincart } = this.$store.state;
      const order = this.getOrder(product, this.size);
      return this.getCartProductQuantity(
        this.isAdmin ? admincart : cart,
        order
      );
    },
    removeOneFromCart(product) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      const order = this.getFoodOrder(product);
      if (!this.isAdmin) {
        this.$store.commit("removeOneFromCart", {
          product: product,
          order: order,
          update: true
        });
      } else {
        this.$store.commit("removeOneFromCart", {
          product: product,
          order: order,
          update: true,
          cart_type: "admin"
        });
      }
    },
    closeQrValidationModal() {
      this.checkQR = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
